import * as appData from '../models/appModels';
import  * as appHelper from '../helpers/appHelper';
import * as dataHelper from '../helpers/dataHelper';
import _ from 'lodash';
import * as OL from '../wrappers/openLearning/openlearning-external';
import * as scormConstants from '../constants/scormConstants';

class openLearningService {
    static initTracking(contentData) {
        return new Promise(function (resolve, reject) {
            let trackingData = Object.assign({}, appData.TRACKING_DATA);

            window.OL(function() {
                // Ready to go!
                window.OL.log("I'm ready!");
            });

            let userData = window.OL.user.data;
            let tracking = {
                suspend_data: trackingData.suspend_data,
                lesson_location: contentData.experience.bites[0].screens[0].screen_id,
                lesson_status: scormConstants.LESSON_STATUS_INCOMPLETE
            };

            if(typeof userData.tracking === 'undefined'){


                window.OL.user.replace({'tracking': tracking}, function(result) {
                    if (!result.success) {
                        window.OL.log("It looks like we don't have the ability to save user data");
                    } else {
                        window.OL.log("saved!");
                    }
                });

                trackingData = Object.assign({}, trackingData, {
                    lesson_location:  contentData.experience.bites[0].screens[0].screen_id,
                    lesson_status: scormConstants.LESSON_STATUS_INCOMPLETE
                });

            }else{
                let screen = appHelper.getScreenById(userData.tracking.lesson_location);
                if(!appHelper.isDefined(screen.screen_id) || userData.tracking.lesson_location === null || !appHelper.isDefined(userData.tracking.lesson_location)){
                    window.OL.user.replace({'tracking': tracking}, function(result) {
                        if (!result.success) {
                            window.OL.log("It looks like we don't have the ability to save user data");
                        } else {
                            window.OL.log("saved!");
                        }
                    });

                    trackingData = Object.assign({}, trackingData, {
                        lesson_location:  contentData.experience.bites[0].screens[0].screen_id,
                        lesson_status: scormConstants.LESSON_STATUS_INCOMPLETE
                    });
                }else{
                    if(typeof userData.tracking.suspend_data !== undefined){
                        trackingData = Object.assign({}, trackingData, {
                            suspend_data: userData.tracking.suspend_data
                        });
                    }

                    if(typeof userData.tracking.lesson_location !== undefined){
                        trackingData = Object.assign({}, trackingData, {
                            lesson_location:  userData.tracking.lesson_location
                        });
                    }else{
                        trackingData = Object.assign({}, trackingData, {
                            lesson_location:  contentData.experience.bites[0].screens[0].screen_id
                        });
                    }

                    if(typeof userData.tracking.lesson_status !== undefined){
                        if(userData.tracking.lesson_status != scormConstants.LESSON_STATUS_COMPLETED){
                            trackingData = Object.assign({}, trackingData, {
                                lesson_status: userData.tracking.lesson_status
                            });
                        }else{
                            trackingData = Object.assign({}, trackingData, {
                                lesson_status: scormConstants.LESSON_STATUS_INCOMPLETE
                            });
                        }

                    }
                }

            }

            trackingData = Object.assign({}, trackingData, {
                initialised: true
            });

            resolve(trackingData);
        });
    }

    static setLessionLocation(lesson_location){
        return new Promise(function (resolve, reject) {
            let userData = window.OL.user.data;
            let tracking = Object.assign({},userData.tracking);
            tracking = Object.assign({}, tracking, {
                lesson_location: parseInt(lesson_location)
            });

            window.OL.user.replace({'tracking': tracking}, function(result) {
                if (!result.success) {
                    window.OL.log("Error saving Lession Location");
                } else {
                    resolve(true);
                }
            });


        });
    }

    static setSuspendData(suspend_data){
        return new Promise(function (resolve, reject) {
            let userData = window.OL.user.data;
            let tracking = Object.assign({},userData.tracking);
            tracking = Object.assign({}, tracking, {
                suspend_data: suspend_data
            });

            window.OL.user.replace({'tracking': tracking}, function(result) {
                if (!result.success) {
                    window.OL.log("Error saving Suspend Data");
                } else {
                    resolve(true);
                }
            });
        });
    }

    static markComplete(bites, contentData) {
        return new Promise(function (resolve, reject) {
            let userData = window.OL.user.data;
            let tracking = Object.assign({},userData.tracking);

            if(tracking.lesson_status != scormConstants.LESSON_STATUS_COMPLETED){

                tracking = Object.assign({}, tracking, {
                    lesson_status: scormConstants.LESSON_STATUS_COMPLETED
                });

                window.OL.user.replace({'tracking': tracking});

                try {
                    let scores = [];
                    let totalScore = 0;
                    let avgScore = 0;
                    let scoreScaled = 0;
                    let scoreMax = 100;

                    _.forEach(bites, function(bite) {
                        let primaryKpi = appHelper.getArrayObjectByKey(bite.kpis, "is_primary", true);
                        let score = dataHelper.getRangePercentage(primaryKpi.min,primaryKpi.max,primaryKpi.current);
                        if(isNaN(score)){
                            score = scormConstants.CMI_CORE_SCORE_MAX_DEFAULT;
                        }
                        scores.push(score);
                        totalScore += score;
                        avgScore = totalScore/scores.length;
                        scoreScaled = new Number(avgScore / scoreMax);


                    });

                    if(avgScore >= 0){
                        window.OL.criteria.replace({completed: true}, "equal", "open");
                        window.OL.user.setProgress(scoreScaled/1);
                    }

                }
                catch(err) {
                    window.OL.log("Error setting score");
                }

                window.OL.user.submit({"completed": true}, function(result) {
                    if (!result.success) {
                        window.OL.log("Error setting completion");
                        resolve(true);
                    } else {
                        window.OL.log("saved completion");
                        resolve(true);
                    }
                    resolve(true);
                });
                resolve(true);
            }else{
                window.OL.user.submit({"completed": true}, function(result) {
                    if (!result.success) {
                        window.OL.log("Error setting completion");
                        resolve(true);
                    } else {
                        window.OL.log("saved completion");
                        resolve(true);
                    }
                });
                resolve(true);
            }
        });
    }
}

export default openLearningService;


/** WEBPACK FOOTER **
 ** ./src/services/openLearningService.js
 **/